import React, { useEffect, useState } from "react";
import { CheckMark } from "../utility_components";
import head from "lodash/head";
import Slider from "antd/es/slider";
import { hummanizeNumber } from "../../../lib/numbers";
export const CheckBoxFilter = ({ options, onChange, values, close }) => {
  const [internalValues, setValues] = useState({});
  useEffect(() => {
    // the internal representation is {[categoryUUID]: bool}, whereas the API uses []categoryUUID. so we have to convert it.
    if (values) {
      setValues(values.reduce((agg, next) => ({ ...agg, [next]: true }), {}));
    } else {
      setValues({});
    }
  }, [values]);
  return (
    <div className={"p-axs"} style={{ maxHeight: 300, overflow: "auto" }}>
      {options.map(({ value, label }) => {
        return (
          <div className={"p-vxxxs flex-row-container"} key={value}>
            <div className={"position-relative"} style={{ width: 20, height: 10 }}>
              <CheckMark
                checked={!!internalValues[value]}
                onClick={e => {
                  setValues({
                    ...internalValues,
                    [value]: e.target.checked,
                  });
                }}
              />
            </div>
            <div className={"m-lxxs"}>{label}</div>
          </div>
        );
      })}
      <FilterFooter
        onReset={() => {
          onChange();
          setValues({});
          close();
        }}
        onOk={e => {
          e.preventDefault();
          const output = Object.entries(internalValues)
            .filter(([key, val]) => val)
            .map(head);
          onChange(output);
          close();
        }}
      />
    </div>
  );
};

const FilterFooter = ({ onReset, onOk }) => {
  return (
    <div className={"flex-row-container justify-space-between m-txxs"}>
      <button
        className="btn btn-tertiary p-hxs p-vxxxs m-b0"
        style={{ minWidth: "0" }}
        onClick={onReset}>
        Reset
      </button>
      <button
        className="btn btn-primary p-hxs p-vxxxs  m-b0"
        style={{ minWidth: "0" }}
        onClick={onOk}>
        OK
      </button>
    </div>
  );
};

export const SliderFilter = ({
  min,
  max,
  close,
  onChange,
  formatNumber = hummanizeNumber,
  values: externalValues,
}) => {
  const [values, setValues] = useState([min, max]);
  const [sliderValues, setSliderValues] = useState([0, 100]);
  useEffect(() => {
    if (externalValues) {
      setValues(externalValues);
    } else {
      setSliderValues([0, 100]);
      setValues([min, max]);
    }
  }, [externalValues]);
  const sliderValueToActualValue = sliderVal => {
    return Math.round(((sliderVal / 100) * (max - min) + min) / 100) * 100;
  };
  const onAfterChange = sliderValues => {
    setValues(sliderValues.map(sliderValueToActualValue));
  };
  return (
    <div className={"p-axs"} style={{ width: 200, height: 152, borderRadius: 16 }}>
      <div>
        <span className="bold black-text">Filtered: </span>
        {values.map(formatNumber).join(" - ")}
      </div>
      <Slider
        range
        onAfterChange={onAfterChange}
        defaultValue={[0, 100]}
        onChange={setSliderValues}
        value={sliderValues}
        tipFormatter={val => formatNumber(sliderValueToActualValue(val))}
      />
      <FilterFooter
        onReset={() => {
          onChange();
          setValues([min, max]);
          setSliderValues([0, 100]);
          close();
        }}
        onOk={e => {
          onChange(values);
          close();
        }}
      />
    </div>
  );
};
